// src/poker/hooks/usePokerStorage.js
import { useEffect, useState } from "react";
import { LS_KEY, buildDefaultLevels } from "../pokerClock.logic";

export default function usePokerStorage({
  settings,
  setSettings,
  levels,
  setLevels,
  levelIndex,
  setLevelIndex,
  remainingSec,
  setRemainingSec,
  running,
  setRunning,
}) {
  const [loadedOnce, setLoadedOnce] = useState(false);

  // Load
  useEffect(() => {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (!raw) {
        setLoadedOnce(true);
        return;
      }
      const parsed = JSON.parse(raw);

      if (parsed?.settings) setSettings(parsed.settings);
      if (Array.isArray(parsed?.levels) && parsed.levels.length) setLevels(parsed.levels);

      if (Number.isFinite(parsed?.levelIndex)) setLevelIndex(parsed.levelIndex);
      if (Number.isFinite(parsed?.remainingSec)) setRemainingSec(parsed.remainingSec);

      // po odświeżeniu zawsze pauza
      if (typeof parsed?.running === "boolean") setRunning(false);
    } catch (e) {
      console.warn("[PokerClock] localStorage load failed:", e);
    } finally {
      setLoadedOnce(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autosave
  useEffect(() => {
    if (!loadedOnce) return;
    try {
      const payload = {
        settings,
        levels,
        levelIndex,
        remainingSec,
        running,
        savedAt: Date.now(),
      };
      localStorage.setItem(LS_KEY, JSON.stringify(payload));
    } catch (e) {
      console.warn("[PokerClock] localStorage save failed:", e);
    }
  }, [loadedOnce, settings, levels, levelIndex, remainingSec, running]);

  const clearStorageAndReset = () => {
    setRunning(false);
    try {
      localStorage.removeItem(LS_KEY);
    } catch (e) {
      // ignore
    }

    setSettings({
      title: "Turniej",
      players: 8,
      startingStack: 20000,
      buyin: 50,
      fee: 0,
      rebuyEnabled: true,
      rebuyChips: 20000,
      rebuyPrice: 50,
      rebuyUntilLevel: 6,
      reentryEnabled: false,
      reentryPrice: 50,
      payoutMode: "percent",
      payout: [
        { place: 1, value: 50 },
        { place: 2, value: 30 },
        { place: 3, value: 20 },
      ],
    });

    const newLvls = buildDefaultLevels(12);
    setLevels(newLvls);
    setLevelIndex(0);
    setRemainingSec(newLvls[0].minutes * 60);
  };

  return { loadedOnce, clearStorageAndReset };
}
